export default __webpack_public_path__ + "static/media/search-no-bg.2596a3e8.svg";